<template>
  <div>
    <v-expansion-panel v-model="tournamentPanel" dark>
      <v-expansion-panel-content
        class="purple darken-4"
        v-for="item in tournaments"
        v-model="tournIndex[item.tournament]"
        :key="item.id"
        v-on:click.native="setTournamentEvents(item.events)"
      >
        <div slot="header" class="tournament-title">
          <span
            ><img
              :src="getSportIconPath(sport)"
              class="tournament-title-icon" /></span
          ><span class="tournament-title-header">{{ item.tournament }}</span>
        </div>
        <v-card>
          <v-card-text class="grey darken-3">
            <v-expansion-panel class="mb-0 full-white-border">
              <v-expansion-panel-content
                accordion
                class="grey darken-2"
                v-for="event in item.events"
                v-model="evbtIndex[event.fixtureId]"
                :key="event.fixtureId"
                v-on:click.native="setEventFixtureId($event, event.fixtureId, event)"
              >
                <div slot="header" class="white-color">
                  <div class="game-header-title">
                    <img
                      class="live-icon"
                      src="../assets/img/live-in-play-icon.png"
                    />
                    <div v-if="event.eventName.length < 45" class="event-name">
                      {{ event.eventName }}
                    </div>
                    <div v-else class="event-name reduce-event-name-size">
                      {{ event.eventName }}
                    </div>
                    <div class="event-date">{{ event.startTime | date }}</div>
                    <div v-if="event" class="event-match-summary">
                      <MatchSummary
                        :matchSummaryData="event"
                        :connection="connection"
                        :sport="sport"
                        :eventId="event.fixtureId"
                      ></MatchSummary>
                    </div>
                  </div>
                  <MatchWinner
                    :connection="connection"
                    :sport="sport"
                    :tournament="item.tournament"
                    :eventId="event.fixtureId"
                    :eventName="event.eventName"
                    :eventTime="event.startTime"
                    :events="events"
                    :expanded="tournIndex[item.tournament]"
                  ></MatchWinner>
                </div>
                <v-card class="grey darken-4">
                  <v-card-text>
                    <!-- Statscore Container -->
                    <div v-if="!event.statscoreIsMapped">
                      <Scoreboard
                        :eventId="event.fixtureId"
                        :connection="connection"
                        :sport="sport"
                      ></Scoreboard>
                    </div>
                    <div v-else>
                      <div style="text-align: center" v-if="isMobile()">
                        <v-btn
                          v-if="showTrackerBtn"
                          v-on:click="showStatscorePlayer()"
                          class="btn-submit-header"
                          color="#020381"
                          style="
                            width: 42%;
                            display: inline-block;
                            text-align: center;
                          "
                          >Match Tracker</v-btn
                        >
                        <v-btn
                          v-if="showStreamBtn"
                          v-on:click="showImgPlayer()"
                          class="btn-submit-header"
                          color="#020381"
                          style="
                            width: 42%;
                            display: inline-block;
                            text-align: center;
                          "
                          >Live Stream</v-btn
                        >
                      </div>
                      <div>
                        <Statscore
                          v-if="isMobile() && showStatscore"
                          :eventObject="event"
                        ></Statscore>
                        <Widget
                          v-if="isMobile() && showImg"
                          :eventObject="event"
                        ></Widget>
                      </div>
                    </div>
                    <EventBetTypes
                      :statscoreId="statscoreId"
                      :connection="connection"
                      :state="event.gameState"
                      :sport="sport"
                      :tournament="item.tournament"
                      :eventId="event.fixtureId"
                      :eventName="event.eventName"
                      :eventTime="event.startTime"
                      :betTypeGroups="betTypes"
                      :expanded="evbtIndex[event.fixtureId]"
                    ></EventBetTypes>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <UpcomingEvents :connection="connection" :sport="sport"></UpcomingEvents>
  </div>
</template>

<script>
import EventBetTypesApi from '../api/eventBetTypes';
import EventBetTypes from "./EventBetTypes.vue";
import TournamentsEventsApi from "../api/tournamentsEvents";
import { HubConnection } from "@aspnet/signalr";
import MatchWinner from "./MatchWinner.vue";
import UpcomingEvents from "./UpcomingEvents.vue";
import MatchSummary from "./MatchSummary.vue";
import Scoreboard from "./Scoreboard.vue";
import Statscore from "./Statscore.vue";
import Widget from "./Widget.vue";
import * as CONFIG from "../config";
import StreamAPI from "../api/streaming";

export default {
  name: "BetOptions",
  components: {
    EventBetTypes,
    MatchWinner,
    UpcomingEvents,
    MatchSummary,
    Scoreboard,
    Statscore,
    Widget,
  },
  data() {
    return {
      showStatscore: true,
      showImg: false,
      showTrackerBtn: false,
      showStreamBtn: false,
      imgPoster: "",
      imgStreamLink: "",
      tournaments: [],
      tournamentPanel: 0,
      evbtIndex: {},
      currentFixtureIds: [],
      betTypes: [],
      tournIndex: {},
      events: [],
    };
  },
  props: {
    sport: String,
    connection: HubConnection,
    statscoreId: Number,
    eventObject: Object,
  },
  watch: {
    sport: function (newSport, oldSport) {
      if (this.sport != "" && oldSport != newSport) {
        for (var i = 0; i < this.currentFixtureIds.length; i++) {
          this.connection.invoke(
            "UnSubscribe",
            this.currentFixtureIds[i] + "eventBetType"
          );
          this.currentFixtureIds.pop();
        }
        this.getEventBetTypes(this.sport);
        this.getTournamentsEvents(this.sport);
      }
    },
    evbtIndex: function () {},
    ueIndex: function () {},
    tournIndex: function () {},
    events: function () {},
  },
  methods: {
    setTournamentEvents(events) {
      this.events = [];
      for (var i = 0; i < events.length; i++) {
        this.events.push(events[i].fixtureId)
      }
    },
    getEventBetTypes(sport) {
      EventBetTypesApi.getEventBetTypes(sport)
        .then(data => {
          this.betTypes = data.responseObject;
        });
    },
    showImgPlayer() {
      this.showImg = true;
      this.showStatscore = false;
    },
    showStatscorePlayer() {
      this.showStatscore = true;
      this.showImg = false;
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    getSportIconPath(sportName) {
      if (sportName) {
        if (this.sport) {
          const svgName = sportName.replace(/\s/g, "-").toLowerCase();
          return require(`../assets/img/icons/${svgName}.svg`);
        }
      }
    },
    getTournamentsEvents(sport) {
      TournamentsEventsApi.getTournamentsEvents(sport).then((data) => {
        this.tournaments = data.responseObject;
        this.setTournamentEvents(this.tournaments[0].events);
      });
    },
    updateFixture(updatedFixture) {
      let tournamentIndex = this.tournaments.findIndex(
        (t) => t.tournament === updatedFixture.Tournament
      );
      if (tournamentIndex !== -1) {
        let i = this.tournaments[tournamentIndex].events.findIndex(
          (t) => t.fixtureId === updatedFixture.FixtureID
        );
        if (i !== -1) {
          //found
          //update fixture name, startTime, etc
          if (
            this.tournaments[tournamentIndex].events[i].startTime !==
            updatedFixture.StartTime
          )
            this.tournaments[tournamentIndex].events[i].startTime =
              updatedFixture.StartTime;
          if (
            this.tournaments[tournamentIndex].events[i].eventName !==
            updatedFixture.EventName
          )
            this.tournaments[tournamentIndex].events[i].eventName =
              updatedFixture.EventName;
          if (
            this.tournaments[tournamentIndex].events[i].status !==
            updatedFixture.Status
          )
            this.tournaments[tournamentIndex].events[i].status =
              updatedFixture.Status;
          if (
            this.tournaments[tournamentIndex].events[i].gameState !==
              updatedFixture.GameState &&
            updatedFixture.GameState !== ""
          ) {
            this.tournaments[tournamentIndex].events[i].gameState =
              updatedFixture.GameState;
          }
        } else {
          //Add the new event
          this.tournaments[tournamentIndex].events.push({
            fixtureId: updatedFixture.FixtureID,
            eventName: updatedFixture.EventName,
            startTime: updatedFixture.StartTime,
          });
        }
      } else {
        //Add the new tournament
        this.getTournamentsEvents(this.sport);
      }
    },
    mergeFixture(api, signalR) {
      let temp = api.map((s) => s.startTime);
      for (let item in signalR) {
        let value = signalR[item].Sport;
        if (temp.indexOf(value) === -1) api.push({ sport: value });
      }
      return api;
    },

    setEventFixtureId(event, fixtureId, eventData) {
      const isStatscoreClick = this.isStatscoreClick(event.target);
      if (!isStatscoreClick) {
        fixtureId = fixtureId.toString();
        if (this.evbtIndex.hasOwnProperty(fixtureId)) {
          this.getMappedEventData(fixtureId);

          this.$emit("childToParent", eventData);
          this.connection.invoke("Subscribe", fixtureId + "eventBetType");
          this.currentFixtureIds.push(fixtureId);
          const configurationId = CONFIG.STATSCORE_CONFIG_ID;
          //Check if div is Empty AND if the ID being generated doesnt exist (WebView only)
          if (
            document.getElementById("statscoreHolder") &&
            document.getElementById("statscoreHolder").innerHTML === "" &&
            !document.getElementById("sp_" + eventData.fixtureId)
          ) {
            if (CONFIG.STATSCORE_WIDGET) {
              
              if (eventData.statscoreIsMapped) {
                var element = document.createElement("div");
                element.id = "sp_" + eventData.fixtureId;
                document.getElementById("statscoreHolder").appendChild(element);
                if (this.isMobile()) {
                  document.getElementById('sp_' + eventData.fixtureId).innerHTML = "";
                  const inputData = 
                  {
                      eventId: 'm:' + eventData.statscoreEventID,
                      lang: 'en',
                      timezone: -120
                  };
                  const options = {};
                  const widget = new window.STATSCOREWidgets.WidgetGroup(element, configurationId, inputData, options);
                } 
                else {
                  const inputData =
                  { 
                      eventId: 'm:' + eventData.statscoreEventID,
                      lang: 'en',
                      timezone: -120
                  };
                  const options = {};
                  const widget = new window.STATSCOREWidgets.WidgetGroup(element, configurationId, inputData, options);
                }
              }
            }
          } 
          else if (document.getElementById("sp_" + eventData.fixtureId)) {
            var element = document.getElementById("sp_" + eventData.fixtureId);
            if (CONFIG.STATSCORE_WIDGET) {
              var element = document.getElementById("sp_" + eventData.fixtureId);
              if (element.firstChild && element.firstChild.className && !element.firstChild.className.includes('STATSCOREWidget')) {
                if (eventData.fixtureId !== fixtureId && this.isMobile()) {
                  document.getElementById("sp_" + eventData.fixtureId).innerHTML = "";
                }

                if (this.isMobile()) {
                  document.getElementById("sp_" + eventData.fixtureId).innerHTML = "";
                  const inputData = 
                  {
                      eventId: 'm:' + eventData.statscoreEventID,
                      lang: 'en',
                      timezone: -120
                  };
                  const options = {};
                  const widget = new window.STATSCOREWidgets.WidgetGroup(element, configurationId, inputData, options);
                } 
                else if (eventData.fixtureId !== fixtureId) {
                    const inputData = 
                    {
                        eventId: 'm:' + eventData.statscoreEventID,
                        lang: 'en',
                        timezone: -120
                    };
                    const options = {};
                    const widget = new window.STATSCOREWidgets.WidgetGroup(element, configurationId, inputData, options);
                }
              }
            }
          }
        } else if (!this.evbtIndex[fixtureId] && fixtureId) {
          if (
            document.getElementById("sp_" + eventData.fixtureId) &&
            this.isMobile()
          ) {
            document.getElementById("sp_" + eventData.fixtureId).innerHTML = "";
          }
          this.connection.invoke("UnSubscribe", fixtureId + "eventBetType");
        }
      }
    },
    isStatscoreClick(target){
      return target.className.includes('STATSCOREWidget');
    },
    getMappedEventData(fixtureId) {
      StreamAPI.getStreamingEvent(fixtureId)
        .then((data) => {
          if (data.responseObject) {
            this.showStreamBtn = true;
            this.showTrackerBtn = true;
          } else {
            this.showStreamBtn = false;
            this.showTrackerBtn = false;
            this.showStatscore = true;
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video-js .vjs-tech {
  width: 100vw;
}
.event-match-summary {
  margin-top: 1px;
  margin-bottom: 2px;
  margin-left: 40px;
  font-size: 10px;
  color: gold;
}

.event-name {
  margin-left: 40px;
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
}

.event-date {
  margin-top: 1px;
  margin-bottom: 2px;
  margin-left: 40px;
  font-size: 10px;
  color: grey;
}

img.live-icon {
  display: inline;
  text-align: left;
  position: absolute;
  /*left: 213px;*/
  background-color: #191927;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 6px;
  padding-right: 6px;
  top: 6px;
}

.tournament-title-icon {
  width: 18px;
  margin-right: 5px;
  vertical-align: sub;
}

.tournament-title {
  font-size: 16px;
  font-weight: bold;
  color: #fff;
}

.white-color {
  color: #fff;
}

.tournament-header {
  background-color: #004369;
}

.tournament-title {
  font-weight: 400;
  padding-left: 10px;
  font-size: 15px;
}

.theme--dark.v-expansion-panel .v-expansion-panel__container {
  border-top: 0px solid #fff !important;
  background-color: #020381 !important;
  margin-bottom: 10px;
}

.sub-header {
  color: gold;
  display: block;
}

.purple.darken-3,
.purple.darken-2 {
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
  border-color: #9f9f9f !important;
  font-weight: 600;
}

.purple.darken-4 {
  background-color: #020381 !important;
  border-color: #020381 !important;
}

.game-header-title {
  background-color: #191927;
  padding-left: 10px;
  padding-top: 8px;
  padding-bottom: 8px;
  height: 60px;
  margin-top: -1px;
  border-bottom: 0px solid #000;
}

.game-header-title span {
  background-color: #382058;
  display: inline;
  padding-top: 20px;
  margin-top: -15px;
  text-align: left;
  float: left;
  padding-top: 6px;
  margin-top: -8px;
  margin-right: 35px;
  padding-left: 15px;
  padding-right: 10px;
  padding-bottom: 4px;
  line-height: 25px;
  min-width: 178px;
  position: absolute;
  left: 0px;
  font-size: 9px;
}

.word-wrap {
  overflow-wrap: break-word;
}

.v-expansion-panel.mb-0.theme--dark > li {
  margin: 0 !important;
}

.upcomingEvents {
  padding-top: 20px;
  background-color: #0a0a0a !important;
}

.upcomingEventsNoSport {
  padding-top: 0px;
}

.grey {
  color: #929292;
}

.grey.darken-3 {
  background-color: #000000 !important;
  border-color: #000000 !important;
}

.v-card__text {
  padding: 0px !important;
  width: 100%;
  border-top: 0px solid #000;
  border-bottom: 0px solid #000;
}

.full-white-border {
  border: 0px solid #fff !important;
}

.disableText.marketName {
  padding-left: 10px;
}

@media (max-width: 480px) {
  img.live-icon {
    /*left: 198px;*/
  }
}

@media (max-width: 320px) {
  .reduce-event-name-size {
    font-size: 9px;
    word-break: break-word;
    overflow-wrap: break-word;
  }
}

/*.v-expansion-panel.mb-0.theme--dark > li:first-child {
        margin-bottom: 5px !important;
    }*/
</style>

